export default __webpack_public_path__ + "static/media/ppt.d5ba26fd.svg";